export default __webpack_public_path__ + "static/ESC_Modal_ROOMSHOT_MOBILE-6acc99cec8d3fd950c572f6f53fdc061.png";